import jump from 'jump.js';

const scrollToErrors = document.querySelector('.scroll-validation-errors');

if (scrollToErrors) {
  jump(scrollToErrors, {
    offset: -200,
  });
}
